// 让 makeModelMap 作为全局变量
window.makeModelMap = {
  
  "BMW": ["E46 NON-M", "E46 M3", "E9X NON-M", "E9X M3", "F8X M3 M4", "G8X M3 M4", "G87 M2"],
  "Chevrolet" :["C6 Corvette Z06"],
  "Toyota": ["GR86 ZN8", "GR SUPRA A90 A91", "GR COROLLA/Yaris"],
  "Tesla": ["MODEL 3"],
  "Honda": ["S2000"],
  "Porsche":["991 GT3"],
};

console.log("✅ Make & Model Data Loaded:", window.makeModelMap);
